export default "__VITE_PUBLIC_ASSET__632ce170__"